import React, {PureComponent} from "react"
import {withRouter, RouteComponentProps} from "react-router"

import {VERSION_COOKIE, GRAPH_URL_COOKIE, API_GW_URL_COOKIE} from "./constant/cookieName"
import clearCookie from "./helpers/clearCookie"
import getCookie from "./helpers/getCookie"
import Row from "./Row"

interface State {
  version?: string | null,
  graphUrl?: string | null,
  apigwUrl?: string | null
}

interface Props extends RouteComponentProps {}

class Version extends PureComponent<Props, State> {
  state: State = {
    version: null,
    graphUrl: null,
    apigwUrl: null
  }

  componentDidMount() {
    this.getVersion()
    this.getGraphUrl()
    this.getApigwUrl()
  }

  getVersion = () => {
    const version = getCookie(VERSION_COOKIE)
    if (version) {
      this.setState({version})
    }
  }

  getGraphUrl = () => {
    const graphUrl = getCookie(GRAPH_URL_COOKIE)
    if (graphUrl) {
      this.setState({graphUrl})
    }
  }

  getApigwUrl = () => {
    const apigwUrl = getCookie(API_GW_URL_COOKIE)
    if (apigwUrl) {
      this.setState({apigwUrl})
    }
  }

  clearVersion = () => {
    clearCookie(VERSION_COOKIE)
    const {href, search} = window.location
    window.location.href = href.replace(search, "")
  }

  clearGraphUrl = () => {
    clearCookie(GRAPH_URL_COOKIE)
    const {href, search} = window.location
    window.location.href = href.replace(search, "")
  }

  clearApigwUrl = () => {
    clearCookie(API_GW_URL_COOKIE)
    const {href, search} = window.location
    window.location.href = href.replace(search, "")
  }

  render() {
    const {version, graphUrl, apigwUrl} = this.state

    return (
      <>
        {version && <Row text="version" value={version} onClear={this.clearVersion} />}
        {graphUrl && <Row text="graph url" value={graphUrl} onClear={this.clearGraphUrl} />}
        {apigwUrl && <Row text="api gw url" value={apigwUrl} onClear={this.clearApigwUrl} />}
      </>
    )
  }
}

export default withRouter(Version)
